import React from 'react';
import { FormStateItem } from '../Form/useFormState';
import RadioBtnGroup, { RadioBtnOption } from '../Form/RadioBtn';
import { HAIR_COLOUR } from '../../data/types';
import { CircleIcon } from '../Icons/Circle';
import { hairColours } from '../../utils/colours';
import { Typography } from '@material-ui/core';
import makeThemedStyles from '../Theme/makeThemedStyles';

const useStyles = makeThemedStyles(theme => ({
  container: {
    marginBottom: theme.spacing(1),
  },
}));

interface Props {
  formItem: FormStateItem;
}

const options: RadioBtnOption[] = [HAIR_COLOUR.BLONDE, HAIR_COLOUR.BRUNETTE, HAIR_COLOUR.AUBURN, HAIR_COLOUR.BLACK, HAIR_COLOUR.GRAY].map(value => ({
  value,
  icon: <CircleIcon />,
  constantColour: hairColours[value],
  bgColour: 'rgba(0, 0, 0, 0.1)',
}));

const HairColourRadio = ({ formItem }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography variant="caption">Hair Colour</Typography>
      <RadioBtnGroup formItem={formItem} options={options} />
    </div>
  );
};

export default React.memo(HairColourRadio);
